import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { AssetDetailsViewTopBar } from "./TopBar"

export const assetDetailsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: AssetDetailsViewTopBar,
}
